import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Eye, EyeOff, ArrowRight, Lock } from 'lucide-react';
interface MambaLoginScreenProps {
  onComplete: (login: string) => void;
}
export function MambaLoginScreen({
  onComplete
}: MambaLoginScreenProps) {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const canContinue = login.trim().length > 0 && password.trim().length > 0;
  return <div className="min-h-screen bg-svt-bg flex flex-col relative overflow-hidden" data-id="element-170">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.03] pointer-events-none" data-id="element-171"></div>
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[400px] h-[400px] bg-gradient-radial from-svt-pink/15 to-transparent rounded-full blur-[80px] pointer-events-none" data-id="element-172"></div>

      {/* Header */}
      <div className="px-6 pt-6 pb-4 flex items-center gap-3" data-id="element-173">
        <img src="https://cdn.magicpatterns.com/uploads/x3zgz2YSJzc57ZhT1dBqrP/logo.png" alt="SVT Dating" className="h-8 w-auto" data-id="element-174" />
        <span className="font-serif text-xl font-bold tracking-wide text-svt-text" data-id="element-175">
          SVT dating
        </span>
      </div>

      {/* Content */}
      <div className="flex-1 flex flex-col justify-center px-6 pb-8 relative z-10" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="flex flex-col items-center mb-8" data-id="element-177">
          <div className="relative mb-6" data-id="element-178">
            <div className="absolute inset-0 bg-gradient-primary opacity-30 blur-2xl rounded-full" data-id="element-179"></div>
            <div className="relative w-16 h-16 rounded-2xl bg-gradient-primary flex items-center justify-center shadow-[0_0_30px_rgba(232,67,147,0.4)]" data-id="element-180">
              <Lock size={28} className="text-white" data-id="element-181" />
            </div>
          </div>

          <h1 className="text-2xl font-bold text-svt-text mb-2 text-center" data-id="element-182">
            Вход
          </h1>
          <p className="text-sm text-svt-text-muted text-center max-w-xs" data-id="element-183">
            Подключите ваш аккаунт, чтобы SVT-агент мог работать за вас
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.1
      }} className="space-y-4" data-id="element-184">
          <div data-id="element-185">
            <label className="block text-xs font-bold tracking-widest uppercase text-svt-text-muted mb-3" data-id="element-186">
              Логин
            </label>
            <input type="email" value={login} onChange={e => setLogin(e.target.value)} placeholder="email@gmail.com" className="w-full px-4 py-3 rounded-2xl bg-svt-surface border border-svt-border text-svt-text placeholder:text-svt-text-faint focus:outline-none focus:border-svt-pink/50 transition-colors" data-id="element-187" />
          </div>

          <div data-id="element-188">
            <label className="block text-xs font-bold tracking-widest uppercase text-svt-text-muted mb-3" data-id="element-189">
              Пароль
            </label>
            <div className="relative" data-id="element-190">
              <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder="Введите пароль" className="w-full px-4 py-3 pr-12 rounded-2xl bg-svt-surface border border-svt-border text-svt-text placeholder:text-svt-text-faint focus:outline-none focus:border-svt-pink/50 transition-colors" data-id="element-191" />
              <button onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2 text-svt-text-muted hover:text-svt-text transition-colors" data-id="element-192">
                {showPassword ? <EyeOff size={18} data-id="element-193" /> : <Eye size={18} data-id="element-194" />}
              </button>
            </div>
          </div>

          <p className="text-xs text-svt-text-faint leading-relaxed pt-2" data-id="element-195">
            текст текст текст
          </p>
        </motion.div>
      </div>

      {/* CTA */}
      <div className="px-6 pb-10" data-id="element-196">
        <button onClick={() => onComplete(login.trim())} disabled={!canContinue} className={`px-12 py-3 rounded-full font-semibold text-base transition-all flex items-center justify-center gap-2 mx-auto ${canContinue ? 'bg-gradient-primary text-white hover:opacity-90 shadow-[0_0_20px_rgba(232,67,147,0.3)]' : 'bg-svt-surface text-svt-text-faint cursor-not-allowed'}`} data-id="element-197">
          Продолжить
          <ArrowRight size={18} data-id="element-198" />
        </button>
      </div>
    </div>;
}